module.exports = __webpack_public_path__ + "media/green-truck.2b11c625.svg";